<template>
   <div class="picker">
       <div class="picker__heading">{{heading}}</div>
       <div class="flex items-center">
           <div v-for="option in options"
                :key="option.id" class="picker__option flex items-center justify-center"
                :class="{'_taken':option.taken,'_selected':selected.indexOf(option.id) > -1}"
                @click="$emit('selectOption',option)"
           >
               {{option.name}}
           </div>
       </div>
   </div>
</template>
<script>
    export default {
        props: {
            heading: String,
            options: Array,
            selected: Array
        }
    }
</script>
<style scoped lang="scss">
    @import '../../../sass/variables';
    .picker {
        &__heading {
            margin-bottom: 1.2rem;

            font-size: 1.4rem;
            font-weight: 400;
            line-height: 1.5;
        }

        &__option {
            width: 5.1rem;
            height: 4.5rem;
            margin-right: 4.3rem;

            font-size: 1.6rem;
            font-weight: 400;
            border: 0.1rem solid $textAndBorder;
            cursor: pointer;
            transition: background 0.2s, color 0.2s;
            user-select: none;

            &:last-child {
              margin-right: 0;
            }

            @media (min-width: $desktop-min-width) {
              margin-right: 1.8rem;
            }
            &._taken {
                border: 0.1rem solid rgba(7,19,47,0.24);
                color: rgba(7,19,47,0.24);
                cursor: default;
            }

            &._selected {
                background: $hypertext;
                color: #ffffff;
                border: 0.1rem solid transparent;
            }
        }
    }
</style>
